import { render, staticRenderFns } from "./initialMetrics.vue?vue&type=template&id=07867cd1&scoped=true"
import script from "./initialMetrics.vue?vue&type=script&lang=js"
export * from "./initialMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07867cd1",
  null
  
)

export default component.exports